// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --accentColor: #008ef4;
  --accentLightColor: rgba(0, 142, 244, 0.1);
  --textOnAcccentColor: white;
  --backgroundColor: #f5f5f5;
  --backgroudSecondaryColor: white;
  --textColor: black;
  --textSecondaryColor: gray;
  --errorColor: red;
  --grayColor: #0000007a;
  --grayLightColor: #0000002b;
  --grayOnAccentColor: #ffffffdb;
  --grayLightOnAccentColor: #ffffff3a;
}

.header_header__MhatS {
  width: 100vw;
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--accentColor);
  padding: 10px;
  color: var(--textOnAcccentColor);
}
.header_header__MhatS .header_container__7HyC8 {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 30px;
}
.header_header__MhatS .header_container__7HyC8 h1 {
  font-size: 20px;
  font-weight: 600;
  min-width: 150px;
}
.header_header__MhatS .header_container__7HyC8 .header_logo__UESgy {
  margin: 0 10px;
  height: 100px;
  max-width: 300px;
  min-width: 200px;
}
.header_header__MhatS .header_container__7HyC8 .header_logo__UESgy img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.header_header__MhatS.header_leftAligned__Biq1A {
  min-height: 64px;
}
.header_header__MhatS.header_leftAligned__Biq1A .header_container__7HyC8 {
  width: 100%;
  max-width: 700px;
  justify-content: flex-start;
}
.header_header__MhatS.header_leftAligned__Biq1A .header_container__7HyC8 .header_logo__UESgy {
  height: 28px;
  min-width: unset;
}
@media (max-width: 900px) {
  .header_header__MhatS.header_leftAligned__Biq1A .header_container__7HyC8 {
    justify-content: flex-start;
  }
  .header_header__MhatS.header_leftAligned__Biq1A .header_container__7HyC8 .header_logo__UESgy {
    height: 50px;
  }
}
.header_header__MhatS.header_fullWidth__ucgcq .header_container__7HyC8 {
  width: 100%;
  align-items: flex-start;
}
.header_header__MhatS.header_fullWidth__ucgcq .header_container__7HyC8 .header_logo__UESgy {
  height: 50px;
}
@media (max-width: 900px) {
  .header_header__MhatS {
    margin-bottom: 10px;
  }
  .header_header__MhatS .header_container__7HyC8 {
    gap: 0px;
    justify-content: center;
  }
  .header_header__MhatS .header_container__7HyC8 .header_logo__UESgy {
    height: unset;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/vars.scss","webpack://./src/components/header/header.module.scss"],"names":[],"mappings":"AAEA;EACE,sBAAA;EACA,0CAAA;EACA,2BAAA;EACA,0BAAA;EACA,gCAAA;EACA,kBAAA;EACA,0BAAA;EACA,iBAAA;EACA,sBAAA;EACA,2BAAA;EACA,8BAAA;EACA,mCAAA;ACDF;;AAXA;EACE,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,aAAA;EACA,gCAAA;AAcF;AAZE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AAcJ;AAZI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AAcN;AAXI;EACE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AAaN;AAXM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAaR;AARE;EACE,gBAAA;AAUJ;AARI;EACE,WAAA;EACA,gBAAA;EACA,2BAAA;AAUN;AARM;EACE,YAAA;EACA,gBAAA;AAUR;AANI;EACE;IACE,2BAAA;EAQN;EANM;IACE,YAAA;EAQR;AACF;AAFI;EACE,WAAA;EACA,uBAAA;AAIN;AAFM;EACE,YAAA;AAIR;AACE;EAxEF;IAyEI,mBAAA;EAEF;EAAE;IACE,QAAA;IACA,uBAAA;EAEJ;EAAI;IACE,aAAA;EAEN;AACF","sourcesContent":["$mobileBP: 900px;\n\n:root {\n  --accentColor: #008ef4;\n  --accentLightColor: rgba(0, 142, 244, 0.1);\n  --textOnAcccentColor: white;\n  --backgroundColor: #f5f5f5;\n  --backgroudSecondaryColor: white;\n  --textColor: black;\n  --textSecondaryColor: gray;\n  --errorColor: red;\n  --grayColor: #0000007a;\n  --grayLightColor: #0000002b;\n  --grayOnAccentColor: #ffffffdb;\n  --grayLightOnAccentColor: #ffffff3a;\n}\n","@import '../../styles/vars.scss';\n\n.header {\n  width: 100vw;\n  min-height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--accentColor);\n  padding: 10px;\n  color: var(--textOnAcccentColor);\n\n  .container {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 30px;\n\n    h1 {\n      font-size: 20px;\n      font-weight: 600;\n      min-width: 150px;\n    }\n\n    .logo {\n      margin: 0 10px;\n      height: 100px;\n      max-width: 300px;\n      min-width: 200px;\n\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n      }\n    }\n  }\n\n  &.leftAligned {\n    min-height: 64px;\n\n    .container {\n      width: 100%;\n      max-width: 700px;\n      justify-content: flex-start;\n\n      .logo {\n        height: 28px;\n        min-width: unset;\n      }\n    }\n\n    @media(max-width: $mobileBP) {\n      .container {\n        justify-content: flex-start;\n\n        .logo {\n          height: 50px;\n        }\n      }\n    }\n  }\n\n  &.fullWidth {\n    .container {\n      width: 100%;\n      align-items: flex-start;\n\n      .logo {\n        height: 50px;\n      }\n    }\n  }\n\n  @media(max-width: $mobileBP) {\n    margin-bottom: 10px;\n\n    .container {\n      gap: 0px;\n      justify-content: center;\n\n      .logo {\n        height: unset;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `header_header__MhatS`,
	"container": `header_container__7HyC8`,
	"logo": `header_logo__UESgy`,
	"leftAligned": `header_leftAligned__Biq1A`,
	"fullWidth": `header_fullWidth__ucgcq`
};
export default ___CSS_LOADER_EXPORT___;
